import { render } from "./PageLoadingSpinner.vue?vue&type=template&id=00d20016"
import script from "./PageLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./PageLoadingSpinner.vue?vue&type=script&lang=js"

import "./PageLoadingSpinner.vue?vue&type=style&index=0&id=00d20016&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__